import LoadingOutlined from "@ant-design/icons/lib/icons/LoadingOutlined";
import Spin from "antd/lib/spin";
import type { FC } from "react";

type LoaderProps = {
  style?: CSSRule;
  className?: string;
};

export const Loader: FC<LoaderProps> = ({ style, className }) => (
  <div className={className}>
    <Spin
      indicator={
        <LoadingOutlined
          style={{
            fontSize: 24,
            color: "#fff",
            ...style,
          }}
          spin
        />
      }
    />
  </div>
);
